'use client';

import { useCallback } from 'react';

import { useReadingV2 } from '@/hooks/use-reading-v2';

export interface UseFanficPageReadingProgressProps {
  fanficId: string;
}

export interface UseFanficPageReadingProgressReturn {
  progressByChapter: { chapterIndex: number; progress: number }[];
  updateReadingProgress: (
    postId: string,
    chapterIndex: number,
    progress: number,
  ) => Promise<boolean>;
  handleProgressSync: (postId: string, chapterIndex: number, nextProgress: number) => void;
}

/**
 * Reading progress for the work page and fullscreen reader sync.
 */
export const useFanficPageReadingProgress = ({
  fanficId,
}: UseFanficPageReadingProgressProps): UseFanficPageReadingProgressReturn => {
  const { progressByChapter, updateReadingProgress, applyLocalProgress } = useReadingV2({
    fanficId,
  });

  const handleProgressSync = useCallback(
    (_postId: string, chapterIndex: number, nextProgress: number) => {
      applyLocalProgress(chapterIndex, nextProgress);
    },
    [applyLocalProgress],
  );

  return {
    progressByChapter,
    updateReadingProgress,
    handleProgressSync,
  };
};
